import React from 'react';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 1 arguments, but got 0.
export default React.createContext();
